import { createContext, useContext } from 'react'
import { type ChatbotListStore } from 'pages/chatbot'

export const ChatbotListContext = createContext<ChatbotListStore | null>(null)

export const useChatbotListContext = () => {
  const context = useContext(ChatbotListContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with ChatbotListProvider')

  return context
}
